import { TableCell as MUITableCell, TableCellProps } from '@mui/material';

export { type TableCellProps } from '@mui/material';

export function TableCell(props: TableCellProps) {
  return <MUITableCell {...props} />;
}
